/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_ThemeInputs */

const cs_settings_prefs_theme = /** @type {(inputs: Settings_Prefs_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzhled`)
};

const en_settings_prefs_theme = /** @type {(inputs: Settings_Prefs_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Settings_Prefs_ThemeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_theme = /** @type {((inputs?: Settings_Prefs_ThemeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_ThemeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_theme(inputs)
	return cs_settings_prefs_theme(inputs)
});